import { v4 as uuidv4 } from "uuid";

interface EmailConfig {
  emailAddress: string;
  displayName: string;
  password?: string;
  organization: string;
  incomingServer: {
    host: string;
    port: number;
    ssl: boolean;
    username: string;
  };
  outgoingServer: {
    host: string;
    port: number;
    ssl: boolean;
    username: string;
  };
}

// XML encoding function to safely encode variables for XML
const xmlEncode = (str: string): string => {
  return str
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
};

export const generateMobileConfig = (config: EmailConfig): string => {
  const payloadUUID = uuidv4();
  const rootUUID = uuidv4();
  const baseIdentifier = `de.hueskehilker.email.${config.emailAddress.replace("@", ".")}`;
  const mailPayloadIdentifier = `${baseIdentifier}.mail`;

  // Handle optional password fields with XML encoding
  const incomingPasswordXML = config.password
    ? `        <key>IncomingPassword</key>
        <string>${xmlEncode(config.password)}</string>`
    : "";

  const outgoingPasswordXML = config.password
    ? `        <key>OutgoingPassword</key>
        <string>${xmlEncode(config.password)}</string>`
    : "";

  return `<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE plist PUBLIC "-//Apple//DTD PLIST 1.0//EN" "https://www.apple.com/DTDs/PropertyList-1.0.dtd">
<plist version="1.0">
  <dict>
    <key>PayloadContent</key>
    <array>
      <dict>
        <key>EmailAccountType</key>
        <string>EmailTypeIMAP</string>

        <key>IncomingMailServerIMAPPathPrefix</key>
        <string>INBOX</string>

        <key>EmailAddress</key>
        <string>${xmlEncode(config.emailAddress)}</string>

        <key>EmailAccountDescription</key>
        <string>${xmlEncode(config.emailAddress)}</string>

        <key>EmailAccountName</key>
        <string>${xmlEncode(config.displayName)}</string>

        <key>IncomingMailServerAuthentication</key>
        <string>EmailAuthPassword</string>

        <key>IncomingMailServerHostName</key>
        <string>${xmlEncode(config.incomingServer.host)}</string>

        <key>IncomingMailServerPortNumber</key>
        <integer>${config.incomingServer.port.toString()}</integer>

        <key>IncomingMailServerUseSSL</key>
        <${config.incomingServer.ssl ? "true" : "false"}/>

        <key>IncomingMailServerUsername</key>
        <string>${xmlEncode(config.incomingServer.username)}</string>
${incomingPasswordXML}

        <key>OutgoingMailServerAuthentication</key>
        <string>EmailAuthPassword</string>

        <key>OutgoingMailServerHostName</key>
        <string>${xmlEncode(config.outgoingServer.host)}</string>

        <key>OutgoingMailServerPortNumber</key>
        <integer>${config.outgoingServer.port.toString()}</integer>

        <key>OutgoingMailServerUseSSL</key>
        <${config.outgoingServer.ssl ? "true" : "false"}/>

        <key>OutgoingMailServerUsername</key>
        <string>${xmlEncode(config.outgoingServer.username)}</string>
${outgoingPasswordXML}

        <key>OutgoingPasswordSameAsIncomingPassword</key>
        <true/>

        <key>PayloadDescription</key>
        <string>${xmlEncode(config.displayName)}</string>

        <key>PayloadDisplayName</key>
        <string>${xmlEncode(config.displayName)}</string>

        <key>PayloadIdentifier</key>
        <string>${xmlEncode(mailPayloadIdentifier)}</string>

        <key>PayloadOrganization</key>
        <string>${xmlEncode(config.organization)}</string>

        <key>PayloadType</key>
        <string>com.apple.mail.managed</string>

        <key>PayloadUUID</key>
        <string>${xmlEncode(payloadUUID)}</string>

        <key>PayloadVersion</key>
        <integer>1</integer>

        <key>PreventAppSheet</key>
        <false/>

        <key>PreventMove</key>
        <false/>

        <key>SMIMEEnabled</key>
        <false/>

        <key>AllowMailDrop</key>
        <true/>
      </dict>
    </array>

    <key>PayloadDescription</key>
    <string>${xmlEncode(config.displayName)} installieren</string>

    <key>PayloadDisplayName</key>
    <string>${xmlEncode(config.displayName)}</string>

    <key>PayloadIdentifier</key>
    <string>${xmlEncode(baseIdentifier)}</string>

    <key>PayloadOrganization</key>
    <string>${xmlEncode(config.organization)}</string>

    <key>PayloadRemovalDisallowed</key>
    <false/>

    <key>PayloadType</key>
    <string>Configuration</string>

    <key>PayloadUUID</key>
    <string>${xmlEncode(rootUUID)}</string>

    <key>PayloadVersion</key>
    <integer>1</integer>
  </dict>
</plist>`;
};
